import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { takeUntil } from 'rxjs/operators';
import { TournamentDetailsService } from 'src/app/services/tournaments/tournament-details.service';
import { CommonTournament, NetworkTournament, Tournament } from 'src/app/services/tournaments/tournaments.models';
import { BasePageComponent } from '../../base-page/base-page.component';
import { TournamentInfoBoxComponent } from '../tournament-info-box/tournament-info-box.component';

@Component({
  selector: 'app-tournament-rules',
  templateUrl: './tournament-rules.component.html',
  styleUrls: ['./tournament-rules.component.scss']
})
export class TournamentRulesComponent extends TournamentInfoBoxComponent {
  // tournamentStartDateLocal: Date;
  // now: Date;
  // @ViewChild('tournamentstartdate') tournamentStartDateElement: ElementRef;


  // @Input() tournament: Tournament;
  description: SafeHtml;


  getDetails() {
    if (this.tournament.isNetworkTournament) {
      this.tournamentDetailsService.getNetworkTournamentDescription(this.tournament.cmsId).pipe(
        takeUntil(this.unsubscribe)
      ).subscribe((desc) => {
        this.description = desc.description;
      })
    }
    else {
      this.tournamentDetailsService.getTournamentDescription(this.tournament.cmsId).pipe(
        takeUntil(this.unsubscribe)
      ).subscribe((desc) => {
        this.description = desc.description;
      })

    }
    this.tournamentStartDateLocal = new Date(this.tournament.startDate);
    this.now = new Date(Date.now());
  }

  ngOnInit(): void {
    this.getDetails();
    const endDate = new Date(new Date().getTime() + (2 * 60 * 60 * 1000));
    if(this.tournament.isNetworkTournament && new Date(this.tournament.endDate)<endDate) {
      this.isFinished = true;
    }
  }

}
